var Enum = Enum || {};

Enum.NOTIFICATION_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    WAIT: 'wait',
    WARNING: 'warning',
    NOTE: 'note'
};

Object.freeze(Enum.NOTIFICATION_TYPE);